import React from 'react'
import "./HeadingTag.scss"

function HeadingTag({ text, tag }) {
  return (
    <>
      <div style={{background:`${tag ? "white" : ""}`}} className="heading-tag">
        <p>{text}</p>

      </div>
    </>
  )
}

export default HeadingTag
